import useStationListStore from '@/stores/stationList'
import { Station } from '@/type/stationType'
import { SITE_STATUS, siteStatusLists } from '@/utils/const'
import { Button, Input, Select, Tabs } from 'antd'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

const SiteFilter: React.FC<{
  stations: Station[]
  onSearch: (run_status: SITE_STATUS, name: string, address: string, type: string) => void
}> = ({ stations, onSearch }) => {
  const { t } = useTranslation()
  const station_type = useStationListStore(state => state.station_type)
  const [status, setStatus] = useState(SITE_STATUS.ALL.toString())
  const [statusMenu, setStatusMenu] = useState<{ label: string; value: number; number: number }[]>(
    siteStatusLists.map(item => ({ ...item, number: 0 }))
  )
  const [statusTab, setStatusTab] = useState<{ key: string; label: React.JSX.Element }[]>([])

  useEffect(() => {
    const statusTemp = statusMenu.map(item => ({
      key: item.value.toString(),
      label: (
        <div className={`plantList-before plantList${item.label}`}>
          {t(`status.${item.label}`)}({item.number})
        </div>
      ),
    }))
    setStatusTab(statusTemp)
  }, [statusMenu, t])

  useEffect(() => {
    if (stations.length > 0) {
      const statusMenuTemp = [...statusMenu]
      statusMenuTemp[0].number = stations.length
      statusMenuTemp[1].number = stations.filter(station => station.run_status === SITE_STATUS.NORMAL).length
      statusMenuTemp[2].number = stations.filter(station => station.run_status === SITE_STATUS.OFFLINE).length
      statusMenuTemp[3].number = stations.filter(station => station.run_status === SITE_STATUS.WARNING).length
      statusMenuTemp[4].number = stations.filter(station => station.run_status === SITE_STATUS.FAULT).length
      statusMenuTemp[5].number = stations.filter(station => station.is_collect == 1).length
      setStatusMenu(statusMenuTemp)
    }
  }, [stations])

  const [name, setName] = useState<string>('')
  const [address, setAddress] = useState<string>('')
  const [type, setType] = useState<string>('')

  const handleFilter = (status: string) => {
    onSearch(Number(status), name, address, type)
  }

  return (
    <div className='PlantLists'>
      <div className='PlantLists-header'>
        <div className='PlantLists-header-left'>
          <Tabs
            defaultActiveKey='1'
            items={statusTab}
            onChange={key => {
              setStatus(key)
              handleFilter(key)
            }}
            activeKey={status}
          />
        </div>
        <div className='PlantLists-header-left-search'>
          <Input placeholder={t('site.siteName')} value={name} onChange={e => setName(e.target.value)} />
          <Input placeholder={t('site.addressOrPostcode')} value={address} onChange={e => setAddress(e.target.value)} />
          <Select
            showSearch
            style={{ width: 200 }}
            placeholder={t('site.siteType')}
            optionFilterProp='label'
            filterSort={(optionA: any, optionB: any) =>
              (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
            }
            value={type}
            onChange={setType}
            options={[
              { value: '', label: t('status.all') },
              ...station_type.map(item => ({ value: item.code_id, label: item.code_name })),
            ]}
          />
          <Button type='primary' ghost onClick={() => handleFilter(status)}>
            {t('common.search')}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default SiteFilter
